import {
  getAllSessions,
  renameSession,
  deleteSession,
} from "~/lib/network/chat-session";

export interface GamgeeChatSession {
  session_id: string;
  title: string;
  created_at: string;
  updated_at: string;
  session_type: string;
  is_busy: boolean;
  is_deleted: boolean;
}

interface ChatSessionsState {
  chatSessions: GamgeeChatSession[];
  fetchChatSessions: () => Promise<void>;
  reset: () => void;
}

const defaultState: ChatSessionsState = {
  chatSessions: [],
  fetchChatSessions: async () => {},
  reset: () => {},
};

export const createChatSessionsSlice = (set: any, get: any, storeApi: any) => {
  return {
    ...defaultState,
    fetchChatSessions: async () => {
      const allSessions = await getAllSessions();
      set((state: ChatSessionsState) => ({ chatSessions: allSessions }));
    },

    renameSession: async (sessionId: string, title: string) => {
      const isRenamed = await renameSession(sessionId, title);
      const updatedSessions = get().chatSessions.map(
        (session: GamgeeChatSession) => {
          if (session.session_id === sessionId)
            return { ...session, title: title };
          return session;
        }
      );
      set((state: ChatSessionsState) => ({ chatSessions: updatedSessions }));
    },

    deleteSession: async (sessionId: string) => {
      const isDeleted = await deleteSession(sessionId);
      const updatedSessions = get().chatSessions.filter(
        (session: GamgeeChatSession) => session.session_id !== sessionId
      );
      set((state: ChatSessionsState) => ({ chatSessions: updatedSessions }));
    },

    reset: () => set(defaultState),
  };
};
